/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { bool, func, shape } from 'prop-types';
import {
	Form, Input, Select
} from 'antd';
import { validateMessages } from '../../utils/validateMessages';
import { layoutNewForm } from '../../utils/utils';
import { Inspector } from '../../entity';
import { FormButtons } from '../../components';
const { Option } = Select;

const EditInspectorForm = ({
	form, onSubmit, isLoading, onCancel
}) => (
	<Form
		initialValues={form}
		{...layoutNewForm}
		labelCol={{span: 12, offset: 0}}	
		wrapperCol={{span: 24}}
		layout={"vertical"}		
		onFinish={onSubmit}
		validateMessages={validateMessages}
		name="nest-messages"
	>

		<Form.Item
			name={['name']}
			label="Nombre"
			rules={[
				{
					required: true
				}
			]}
		>
			<Input />
		</Form.Item>
		<Form.Item
			name={['lastName']}
			label="Apellido"
			rules={[
				{
					required: true
				}
			]}
		>
			<Input />
		</Form.Item>
		<Form.Item
			name={['email']}
			label="Email"
			rules={[
				{
					required: true,
					type: 'email'
				}
			]}
		>
			<Input />
		</Form.Item>
		<Form.Item
			name={['internalIdentifier']}
			label="Cod. interno"
			
		>
			<Input disabled={true}/>
		</Form.Item>
		<Form.Item
			name={['dni']}
			label="DNI"
			rules={[
				{
					required: true,
				}]}
		>
			<Input style={{
				width: '100%',
			}} />
		</Form.Item>
		<Form.Item
			name="category"
			label="Categoría"
			rules={[
				{
					required: true,
				},
			]}
		>
			<Select >
				<Option value="INICIAL">Inicial</Option>
				<Option value="PLENO">Pleno</Option>
			</Select>
		</Form.Item>
		<Form.Item
			name={['password']}
			label="Contraseña temporal"

		>
			<Input disabled={true}/>
		</Form.Item>
		
		<FormButtons isLoading={isLoading} onCancel={onCancel} />
	</Form >
);

EditInspectorForm.propTypes = {
	form: shape(Inspector).isRequired,
	onSubmit: func.isRequired,
	onCancel: func.isRequired,
	isLoading: bool
};

EditInspectorForm.defaultProps = {
	isLoading: false
};

export default EditInspectorForm;
